<template>
<v-dialog v-model="isVisible" max-width="1000">
    <v-card>
        <v-container>
            <candle-chart ref="chart" :chart-data="graphData" style="max-width: 850px; height: 500px; margin: auto" />
            <v-row class="mt-3" justify="center">
                <v-btn color="red" @click="close">닫 기</v-btn>
            </v-row>
        </v-container>
    </v-card>
</v-dialog>
</template>

<script>
import CandleChart from '@/views/charts/CandleChart'

export default {
    name: 'prices-dialog',
    components: {
        CandleChart,
    },
    data() {
        return {
            isVisible: false,
            rawData: '',
            graphData: {}
        }
    },
    watch: {
        rawData(value) {
            value = value.map(v => {
                v.t = new Date(v.t).toISOString().substring(0, 7)
                return v
            })

            this.graphData = {
                datasets: [{
                    backgroundColor: '#f87979',
                    data: value
                }]
            }

            this.growthData = Object.assign({}, this.growthData)
        }
    },
    computed: {},
    methods: {
        show(rawData) {
            this.rawData = rawData
            this.isVisible = true
        },
        close() {
            this.isVisible = false
        },
    }
}
</script>
